import { createRoute, redirect } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { JSON, Watch } from 'domains/Workspaces/Video/Objects/Object'
import { videoObjectsRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects'
import { Structure } from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object/Structure'

export const videoObjectRoute = createRoute({
  getParentRoute: () => videoObjectsRoute,
  path: DynamicRouteParameterWPrefix.VIDEOOBJECT_ID,
  beforeLoad: ({ location, params: { videoobjectId } }) => {
    const encodedParam = encodeURIComponent(videoobjectId)
    if (location.pathname.endsWith(encodedParam) || location.pathname.endsWith(`${encodedParam}/`)) {
      throw redirect({ replace: true, from: videoObjectRoute.fullPath, to: videoObjectConfigRoute.to })
    }
  },
  loader: () => ({
    crumb: t('entity:content.videoObject', { count: 1 }),
  }),
})

export const videoObjectLayoutRoute = createRoute({
  getParentRoute: () => videoObjectRoute,
  id: 'videoObjectLayout',
  component: Structure,
})

export const videoObjectWatchRoute = createRoute({
  getParentRoute: () => videoObjectLayoutRoute,
  path: StaticRouteParameter.WATCH,
  component: () => <Watch />,
})

export const videoObjectConfigRoute = createRoute({
  getParentRoute: () => videoObjectLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: () => <JSON />,
})
